export default "__VITE_ASSET__cn$B_w4W__"